/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkUploadDocument } from './BulkUploadDocument';
import {
    BulkUploadDocumentFromJSON,
    BulkUploadDocumentFromJSONTyped,
    BulkUploadDocumentToJSON,
} from './BulkUploadDocument';

/**
 * 
 * @export
 * @interface ExecuteBulkUploadDocumentsRequest
 */
export interface ExecuteBulkUploadDocumentsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExecuteBulkUploadDocumentsRequest
     */
    lead_ids: Array<string>;
    /**
     * 
     * @type {Array<BulkUploadDocument>}
     * @memberof ExecuteBulkUploadDocumentsRequest
     */
    documents: Array<BulkUploadDocument>;
    /**
     * 
     * @type {boolean}
     * @memberof ExecuteBulkUploadDocumentsRequest
     */
    include_in_ai_analysis: boolean;
}

/**
 * Check if a given object implements the ExecuteBulkUploadDocumentsRequest interface.
 */
export function instanceOfExecuteBulkUploadDocumentsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_ids" in value;
    isInstance = isInstance && "documents" in value;
    isInstance = isInstance && "include_in_ai_analysis" in value;

    return isInstance;
}

export function ExecuteBulkUploadDocumentsRequestFromJSON(json: any): ExecuteBulkUploadDocumentsRequest {
    return ExecuteBulkUploadDocumentsRequestFromJSONTyped(json, false);
}

export function ExecuteBulkUploadDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteBulkUploadDocumentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
        'documents': ((json['documents'] as Array<any>).map(BulkUploadDocumentFromJSON)),
        'include_in_ai_analysis': json['include_in_ai_analysis'],
    };
}

export function ExecuteBulkUploadDocumentsRequestToJSON(value?: ExecuteBulkUploadDocumentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_ids': value.lead_ids,
        'documents': ((value.documents as Array<any>).map(BulkUploadDocumentToJSON)),
        'include_in_ai_analysis': value.include_in_ai_analysis,
    };
}

